import { defineNuxtPlugin } from '#imports'
import { initStore } from '@/app/store'
import { initServicesForStore } from '@b2ag/store'

import {
  discountService,
  offerService,
  searchService,
  productService,
  cartService,
  shoppingListApiClient,
} from '@/app/services'

export default defineNuxtPlugin({
  name: 'store',
  enforce: 'pre',
  dependsOn: ['auth service'],
  async setup(nuxtApp) {
    const store = await initStore()

    nuxtApp.vueApp.use(store)
    nuxtApp.provide('store', store)

    if (import.meta.server) {
      // eslint-disable-next-line no-param-reassign
      nuxtApp.payload.vuex = JSON.parse(JSON.stringify(store.state))
    } else if (nuxtApp.isHydrating && nuxtApp.payload && nuxtApp.payload.vuex) {
      // store.replaceState(nuxtApp.payload.vuex) // XJU: Disable for now
    }

    initServicesForStore({
      searchService,
      discountService,
      offerService,
      productService,
      cartService,
      shoppingListApiClient,
    })
  },
})
